module.exports = __webpack_public_path__ + "static/media/cloud-b-v3.f0bd6990.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-b-v3.svg
// module id = 94
// module chunks = 0